import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon, IconDirectionality } from './tools';
export const Collapse = createSvgIcon('0 0 24 24', IconDirectionality.All, _jsx("path", { fill: 'currentColor', fillRule: 'evenodd', d: 'M19 18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1zm-9.332 0L4 12l5.668-6L11 7.41 6.673 12 11 16.59z', clipRule: 'evenodd' }));
